import React from "react";

export const FinalCtaSection = () => {
  return (
    <section className="text-white py-24 px-4 sm:px-6 lg:px-8 font-sora bg-[#05070a]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">
          Revolutionize Your <span className="text-[#3CEFDC]">Content</span>
        </h2>
        <p className="mt-5 text-gray-400 text-sm sm:text-[15px] mx-auto font-light leading-relaxed text-center">
          Experience the power of Twinnee AI. Transforming simple ideas into cinematic<br />
          masterpieces with a single tap.
        </p>
      </div>
    </section>
  );
};

export default FinalCtaSection;
